import { Col, Row } from "antd";
import Button from "../Button";

interface FooterModalProps {
  onCancel: () => void;
  onOk?: () => void;
}

export const FooterModal: React.FC<FooterModalProps> = ({ onCancel, onOk }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Button size="large" className="full-width" onClick={onCancel}>
          Cancelar
        </Button>
      </Col>
      <Col span={12}>
        <Button
          size="large"
          type="primary"
          className="full-width"
          onClick={onOk ? onOk : undefined}
          htmlType={onOk ? undefined : "submit"}
        >
          Salvar
        </Button>
      </Col>
    </Row>
  );
};
